const api = "https://py.preciouscarbon.com/roa/graphql";
const diamondListApiFunc = "diamondData";
const diamondDetailApiFunc = "diamondById";
const diamondSearchApiFunc = "diamondByStockorcert";
const gemstoneListApiFunc = "gemstoneData";
const baseCurrencyCode = "AUD";
const currencySymbol = "$";
const currencyCode = "AUD";
const settingMinPrice = "1";
const settingMaxPrice = "20000";
const diamondMinPrice = "80";
const diamondMaxPrice = "500000";
const availableCurrencies = "AUD,EUR,GBP";
const baseUrl = window.location.origin;

const this_ring_can_be_set_with = "this-ring-can-be-set-with";
const engagement_ring_metal_type = "engagement-ring-metal-type";
const emailUsFormId = "7382";
const tiWishlistHashKey = "ti_wishlist_data_aed98f24defa22cabcbea96def7b9041";
const contactTelephoneNumber = "+61 452 656 656";
const engRingShippingDays = "14";
const diamondReturnDays = "30";

// Utility functions
const getBaseUrl = () => {
  return window.location.pathname.includes("pages")
    ? `/pages/`
    : window.location.pathname.includes("collections")
    ? `/collections/`
    : `/`;
};

const getVueBasePath = () => {
  return ``; // Adjust this logic if necessary
};

const vueBaseUrl = getBaseUrl();
const baseAssetsUrl = `${window.location.origin}/cdn/shop/t/9/assets`;

// Routes configuration
const routes = [
  {
    path: "/",
    name: "entryPage",
    component: EntryPageComp,
    children: [
      {
        path: ":diamondTab/diamonds",
        name: "diamondDetailPage",
        component: DiamondDetailPageComp,
        props: (route) => ({ diamondId: route.query.diamondId }),
        beforeEnter: (to, from, next) => {
          if (to.query.diamondId) {
            next();
          } else {
            next({ name: "diamondsByShape", params: { diamondType: to.params.diamondTab } });
          }
        },
      },
      {
        path: ":diamondType",
        name: "diamondsByShape",
        component: ChooseDiamondsComp,
        children: [
          {
            path: ":shape",
            name: "diamondsByShapeDetail",
            component: ChooseDiamondsComp,
            props: true,
            beforeEnter: (to, from, next) => {
              if (to.params.shape) {
                next();
              } else {
                next({ name: "diamondsByShape", params: { diamondType: to.params.diamondType } });
              }
            },
          },
        ],
      },
      {
        path: "engagement-rings",
        name: "chooseSetting",
        component: ChooseSettingComp,
        children: [
          {
            path: ":setting",
            name: "chooseSettingStyle",
            component: ChooseSettingComp,
            props: true,
            beforeEnter: (to, from, next) => {
              if (to.params.setting) {
                next();
              } else {
                next({ name: "chooseSetting" });
              }
            },
          },
        ],
      },
      {
        path: "engagement-rings/products/:settingId",
        name: "engagementSettingDetailPage",
        component: SettingDetailPageComp,
        props: true,
      },
      {
        path: "products/:settingId",
        name: "productSettingDetailPage",
        component: SettingDetailPageComp,
        props: true,
      },
      {
        path: "final-ring",
        name: "finalRingPage",
        component: FinalRingDetailPageComp,
        // Shared final-ring links only carry ?data=<encoded payload> (see
        // buildFinalRingUrl in ring-builder-common-components.js). The page
        // component itself still reads settingId/diamondId/ringSize/etc. as
        // plain query params (many call sites), so expand the payload onto
        // `to.query` in place here, before the component mounts, rather than
        // rewriting every read site. Mutating `to.query` (instead of calling
        // next({ name, query })) keeps the visible address bar on the opaque
        // ?data=<hash> URL — a next({ query }) call would instead push a new
        // history entry with the expanded plaintext params, which is exactly
        // the rewrite this is designed to avoid.
        beforeEnter: (to, from, next) => {
          if (!to.query.data || to.query.settingId) {
            next();
            return;
          }
          const isPlainJson = to.query.data.trim().startsWith("{");
          const decoded = decodeRingData(to.query.data, !isPlainJson);
          if (!decoded?.setting?.id || !decoded?.diamond?.diamondId) {
            next();
            return;
          }
          to.query.settingId = String(decoded.setting.id);
          to.query.diamondId = String(decoded.diamond.diamondId);
          to.query.diamondType = decoded.diamond.diamondType || "";
          if (decoded.setting.settingSize && decoded.setting.settingSize !== "Select Ring Size") {
            to.query.ringSize = decoded.setting.settingSize;
          }
          if (decoded.setting.settingMetal) {
            to.query.settingMetal = decoded.setting.settingMetal;
          }
          if (decoded.setting.settingVideo) {
            to.query.settingVideo = decoded.setting.settingVideo;
          }
          if (decoded.setting.bandWidth) {
            to.query.bandWidth = decoded.setting.bandWidth;
          }
          if (decoded.setting.prongType) {
            to.query.prongType = decoded.setting.prongType;
          }
          if (decoded.setting.engravingText) {
            to.query.engravingText = decoded.setting.engravingText;
          }
          if (decoded.matchingBandId) {
            to.query.matchingBandId = String(decoded.matchingBandId);
          }
          if (decoded.secondDiamond?.diamondId) {
            to.query.secondDiamondId = String(decoded.secondDiamond.diamondId);
            to.query.secondDiamondType = decoded.secondDiamond.diamondType || "";
          }
          // Belt-and-suspenders: force the address bar back to the opaque
          // ?data=<hash> form via the native History API, in case the router's
          // own history sync ever picks up the mutated (expanded) query above
          // instead of the original resolved fullPath. replaceState doesn't
          // trigger a navigation/popstate, so this can't create a loop or
          // re-run this guard.
          const hashOnlyPath = to.fullPath;
          next();
          if (typeof window !== "undefined" && window.history?.replaceState) {
            window.history.replaceState(window.history.state, "", hashOnlyPath);
          }
        },
      },
    ],
  },
];

// Vue Router and App initialization
const i18n = VueI18n.createI18n({
  locale: "en",
});

const router = VueRouter.createRouter({
  mode: "history", // Important for Shopify compatibility
  history: VueRouter.createWebHistory(vueBaseUrl),
  routes,
});


const vueApp = Vue.createApp({
  delimiters: ["[[", "]]"],
  template: `<router-view></router-view>`,
});

// <pc-deposit-card> / <pc-deposit-pill> in the final-ring and diamond templates
// are the theme's own web components (snippets/deposit-picker.liquid), not Vue
// components — render them as plain elements instead of trying to resolve them.
vueApp.config.compilerOptions.isCustomElement = (tag) => tag.startsWith("pc-");

const app = vueApp
  .use(i18n)
  .use(router)
  .use(ElementPlus)
  .mount("#ring-builder-app");
